export enum WidgetType {
    ChallengeWidget = "ChallengeWidget",
    UpdateWidget = "UpdateWidget",
    MatchWidget = "MatchWidget",
}